import { Box, Button, Grid, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import useExploratoryColumns from "../../components/Exploaratory/useExploratoryColumns";
import { DataGridComponent } from "../../components/common/DataGridComponent";
import { useExploratoryDetails } from "../../components/Exploaratory/useExploratoryDetails";
import { AlertDialog } from "../../components/common/AlertDailog";
import AddEAModalForm from "../../components/Exploaratory/AddEAModalForm";
import AddIcon from "@mui/icons-material/Add";

const ExploratoryAnalysis: React.FunctionComponent<any> = () => {
  const navigate = useNavigate();
  const columns = useExploratoryColumns();
  const { rowData } = useExploratoryDetails();
  const actions = {
    exploratory_id: (data: any) => {
      navigate(`/exploratory-analysis/${data?.exploratory_id}`);
    },
    studyID: (data: any) => {
      //   console.debug(data);
    },
    assessmentPlan: (data: any) => {
      //   console.debug(data);
    },
  };

  const [openAddEAModal, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleCloseAddEA = () => {
    setOpen(false);
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs>
          <Typography variant="h4" gutterBottom>
            Exploratory Analysis
          </Typography>
        </Grid>
        <Grid item justifyContent="flex-end">
          <Button
            variant="contained"
            endIcon={<AddIcon />}
            onClick={handleClickOpen}
          >
            Add New
          </Button>
        </Grid>
      </Grid>
      <Box sx={{ width: "100%", height: "calc(100vh - 160px)" }}>
        <DataGridComponent
          columns={columns as any}
          hasDefinedColumns={false}
          rows={rowData ?? []}
          showQuickFilter
          actions={actions}
        />
      </Box>

      <AlertDialog
        open={openAddEAModal}
        title="Create New Exploratory Analysis"
        handleClose={handleCloseAddEA}
        //  handleConfirm={handleSubmit(submit, onInvalid)}
        maxWidth="md"
      >
        <AddEAModalForm />
      </AlertDialog>
    </>
  );
};

export default ExploratoryAnalysis;
